import type { FC, ReactNode } from "react";
import InformationIcon from "../icons/InformationIcon";
import Tooltip, { type TooltipPlacement } from "./Tooltip";

export interface InfoTooltipProps {
  text: ReactNode;
  placement?: TooltipPlacement;
  className?: string;
}

/**
 * Convenience: an info "ⓘ" icon that reveals help text on hover/focus.
 * Thin wrapper over ui/Tooltip. Supersedes common/InfoTooltip.
 */
const InfoTooltip: FC<InfoTooltipProps> = ({
  text,
  placement = "top",
  className,
}) => {
  return (
    <Tooltip content={text} placement={placement} className={className}>
      <button
        type="button"
        aria-label="More information"
        className="inline-flex items-center justify-center rounded-pill text-menu/60 hover:text-secondary focus-visible:outline-none focus-visible:ring focus-visible:ring-offset-0"
      >
        <InformationIcon />
      </button>
    </Tooltip>
  );
};

export default InfoTooltip;
